'use strict';

var angular = require('angular');
var dependencies = ['AVRO.ROM.TrendChart'];
module.exports = angular.module('AVRO.ROM.TrendChartPanel', dependencies).directive('rmTrendChartPanel', require('./directives/TrendChartPanelDirective'));